import React from "react";

const BookingConsultations = () => (
  <>
    <style>{`
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.9);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      .booking-header {
        animation: slideInUp 0.8s ease-out;
      }

      .booking-card {
        animation: scaleIn 0.6s ease-out;
        transition: all 0.4s ease;
      }

      .booking-card:nth-child(1) { animation-delay: 0.1s; }
      .booking-card:nth-child(2) { animation-delay: 0.2s; }

      .booking-card:hover {
        transform: translateY(-15px);
        box-shadow: 0 25px 50px rgba(59, 130, 246, 0.2);
      }

      .booking-btn {
        transition: all 0.3s ease;
      }

      .booking-btn:hover {
        transform: scale(1.05);
      }
    `}</style>

    <section id="bookings" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16 booking-header">
          <span className="inline-flex items-center gap-2 bg-blue-100 border border-blue-200 rounded-full px-4 py-2 text-xs font-semibold text-blue-600 mb-6">
            <span className="w-2 h-2 bg-blue-600 rounded-full" />
            Flexible Healthcare Access
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Physical & Online Consultations
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Choose how you want to receive care. Book in-person visits to our centers or consult with doctors from the comfort of your home.
          </p>
        </div>

        {/* Booking Options */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {[
            {
              icon: "🏥",
              title: "Physical Consultation",
              desc: "Visit our nearest channel center for comprehensive in-person medical evaluation",
              features: [
                "Face-to-face with certified doctors",
                "Complete physical examination",
                "Immediate prescriptions",
                "Lab tests available on-site",
                "Average wait time: 15-20 minutes"
              ],
              color: "from-blue-500 to-cyan-500"
            },
            {
              icon: "💻",
              title: "Online Consultation",
              desc: "Video or audio consultation with our network doctors anytime, anywhere",
              features: [
                "Video/audio consultations",
                "Prescription delivery to nearest pharmacy",
                "Digital health records",
                "24/7 availability",
                "Safe and secure connections"
              ],
              color: "from-teal-500 to-emerald-500"
            }
          ].map((option, idx) => (
            <div key={idx} className="booking-card bg-gradient-to-br from-white to-gray-50 rounded-2xl p-8 shadow-lg border border-gray-200 hover:border-transparent">
              <div className="text-6xl mb-4">{option.icon}</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{option.title}</h3>
              <p className="text-gray-600 mb-6">{option.desc}</p>
              
              <div className="mb-8">
                <h4 className="font-semibold text-gray-900 mb-4">What's Included:</h4>
                <ul className="space-y-2">
                  {option.features.map((feature, i) => (
                    <li key={i} className="text-gray-600 leading-relaxed">
                      <span className="text-blue-600 font-bold text-lg">●</span> {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <button className={`booking-btn w-full bg-gradient-to-r ${option.color} text-white py-3 rounded-lg font-bold hover:shadow-lg`}>
                Download App
              </button>
            </div>
          ))}
        </div>

        {/* Easy Booking Process */}
        <div className="bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD] rounded-2xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-12 text-center">Simple Booking Process</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: "1", icon: "📱", title: "Select Type", desc: "Choose physical or online" },
              { step: "2", icon: "🗓️", title: "Pick Date/Time", desc: "Select your preferred slot" },
              { step: "3", icon: "👨‍⚕️", title: "Choose Doctor", desc: "Pick your doctor or auto-match" },
              { step: "4", icon: "✅", title: "Confirm", desc: "Get instant confirmation" }
            ].map((item) => (
              <div key={item.step} className="text-center">
                <div className="text-5xl mb-3">{item.icon}</div>
                <div className="bg-white/20 rounded-lg px-3 py-2 font-bold mb-2 inline-block">Step {item.step}</div>
                <h4 className="font-bold text-lg mb-1">{item.title}</h4>
                <p className="text-white/80 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default BookingConsultations;
